import { useRef } from 'react';

const useCache = (ttl = 5 * 60 * 1000) => {
  const cacheRef = useRef(new Map());

  const get = (key) => {
    const cached = cacheRef.current.get(key);
    if (!cached) return null;

    const isExpired = Date.now() - cached.timestamp > ttl;
    if (isExpired) {
      cacheRef.current.delete(key);
      return null;
    }

    return cached.data;
  };

  const set = (key, data) => {
    cacheRef.current.set(key, {
      data,
      timestamp: Date.now(),
    });
  };

  const clear = () => {
    cacheRef.current.clear();
  };

  return { get, set, clear };
};

export default useCache;
